var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-3"},[_c('BlocksList')],1),_c('div',{staticClass:"column"},[_c('BlockEditor')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }